import React, {
  FC, Fragment, useEffect, useState,
} from 'react';
import { User, LogOut } from 'react-feather';
import { useTranslation } from 'react-i18next';

import CustomIcon from '../CustomIcon';
import { OtherTypes } from '../CustomIcon/types';
import defaultImage from 'assets/images/defaultImage.png';
import Dropdown from 'components/base/Dropdown';
import config from 'config';

import { useProvidedAuth } from 'hooks/useProvidedAuth';
import useUrlTranslation from 'hooks/useUrlTranslation';
import './index.scss';
import { Base64Data } from 'models/Base64Data';
import { MimeTypes } from 'models/Base64Data/MimeTypes';
import { useSettings } from 'modules/settings/hooks/useSettings';
import { getUserDisplayName } from 'utils/userUtils';

const Topbar: FC = () => {
  const { translation } = useUrlTranslation();
  const [header, setHeader] = useState<string>('');
  const { exit, user } = useProvidedAuth();
  const { t } = useTranslation();
  const [imagePreview, setImagePreview] = useState<string>('');
  const { isSettingsEnabled } = useSettings();

  useEffect(() => {
    setHeader(translation);
  }, [translation]);

  useEffect(() => {
    if (user?.image) {
      setImagePreview(`data:${MimeTypes.IMAGE_PNG}${Base64Data.BASE64_GLU}${user?.image}`);
    } else {
      setImagePreview('');
    }
  }, [user?.image]);

  return (
    <div className="funus-topbar">
      <div className="funus-topbar-collapsable">
        <div className="topbar-left">{header}</div>
        <div className="topbar-right">
          <Dropdown
            buttonContent={(
              <Fragment>
                {imagePreview ? (
                  <img alt="Add icon" className="image" src={imagePreview} />
                ) : (
                  <img alt={user?.name || 'user-profile'} src={defaultImage} />
                )}
                <div>
                  <span>{getUserDisplayName(user)}</span>
                  <span>
                    {user?.role?.name
                      ? t(`role.${user.role.name}`, user.role.name)
                      : ''}
                  </span>
                </div>
              </Fragment>
            )}
            className="user-info"
            options={[
              {
                icon: <User />,
                key: 'profile',
                text: `${t('menu.userProfile')}`,
                url: config.url.userProfile,
              },
              ...isSettingsEnabled ? [
                {
                  icon: <CustomIcon icon={OtherTypes.BUDGET_CONFIG} />,
                  key: 'settings',
                  text: `${t('menu.settings')}`,
                  url: config.url.settings,
                },
              ] : [],
              {
                color: 'transparent',
                icon: <LogOut />,
                key: 'logout',
                onClick: exit,
                text: `${t('menu.logout')}`,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default Topbar;
